"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  // One particular add-to-basket notification bubble popup (multiple can be displayed at a time)
  TestId["Popup"] = "popup";
  return TestId;
}({});
